import * as TYPES from './patient-actiontypes';
import * as API from './patient-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as Actions from './patient-action-creator';

export const setPatientData = (patientData) => {
  const state = {
    patientId: patientData.patientId,
    firstName: patientData.firstName,
    lastName: patientData.lastName,
    userId: patientData.userId,
    hasLogin: patientData.hasLogin,
    homeFacilityId: patientData.homeFacilityId,
    dateOfBirth: patientData.dateOfBirth,
    emailAddress: patientData.emailAddress,
  };

  return {
    type: TYPES.SET_PATIENT_DATA,
    state,
  };
};

export const loadPatient = (patientId) => (dispatch) =>
  API.getPatient(patientId)
    .then(
      (response) => {
        dispatch(setPatientData(response.data));
      },
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );


export const loadPatientAddress = (patientId) => (dispatch) =>
  API.getPatientAddress(patientId)
    .then(
      (response) => dispatch(Actions.loadPatientAddress(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );
